<div
  [class]="
    'relative grid gap-(--visitcard-gap) px-(--visitcard-padding-x) py-(--visitcard-padding-y) rounded-(--visitcard-border-radius) ' +
    (config().border ? 'border border-(--visitcard-border-color)' : '')
  "
  [style.background]="containerBackground()"
>
  @if (config().canDismiss) {
    <div class="absolute top-0 right-0 pt-(--visitcard-padding-y) pr-(--visitcard-padding-x)">
      <app-dynamic
        componentName="IconButton"
        [props]="{ config: { icon: 'x', size: 'sm', ariaLabel: 'Close' } }"
        (action)="onClose()"
      />
    </div>
  }

  @if (chipConfig()) {
    <app-dynamic
      componentName="Chip"
      [props]="{ config: chipConfig() }"
    />
  }

  <div class="flex flex-col gap-1 w-full">
    @for (title of normalizedTitles(); track $index) {
      <app-dynamic
        componentName="DynamicText"
        [props]="{
          config: {
            text: title.text,
            size: 'xl',
            fontWeight: 'semibold',
            color: title.color,
          },
        }"
      />
    }
  </div>

  @if (config().subtext) {
    <div class="w-full">
      <app-dynamic
        componentName="DynamicText"
        [props]="{
          config: {
            text: config().subtext!,
            size: 'sm',
            fontWeight: 'bold',
            color: isHighlighted() ? 'var(--visitcard-highlighted-subtext)' : 'var(--visitcard-idle-subtext)',
          },
        }"
      />
    </div>
  }

  @if (config().buttons?.length) {
    <div class="flex flex-col gap-3 w-full">
      @for (buttonConfig of config().buttons; track $index) {
        <app-dynamic
          componentName="Button"
          [props]="{ config: buttonConfig }"
          (action)="onButtonClick($event)"
        />
      }
    </div>
  }
</div>
